import { DetailedOrderType, RequestCancelOrderItemsType } from 'b2b-common/core/account/api/orders';
import {
  CANCEL_ORDER,
  CANCEL_ORDER_FULFILLED,
  CANCEL_ORDER_ITEMS,
  CANCEL_ORDER_ITEMS_FULFILLED,
  CANCEL_ORDER_ITEMS_REJECTED,
  CANCEL_ORDER_REJECTED,
  CLEAR_ACCOUNT_ORDER,
  CLEAR_ORDER_MODIFICATIONS,
  FETCH_ORDER,
  FETCH_ORDER_FULFILLED,
  FETCH_ORDER_REJECTED,
  SPLIT_ORDER,
  SPLIT_ORDER_FULFILLED,
  SPLIT_ORDER_REJECTED,
} from './actionTypes';
import {
  CancelOrderAction,
  CancelOrderFulfilledAction,
  CancelOrderItemsAction,
  CancelOrderItemsFulfilledAction,
  CancelOrderItemsRejectedAction,
  CancelOrderRejectedAction,
  ClearAccountOrderAction,
  ClearOrderModificationsAction,
  FetchOrderAction,
  FetchOrderFulfilledAction,
  FetchOrderRejectedAction,
  SplitOrderAction,
  SplitOrderFulfilledAction,
  SplitOrderRejectedAction,
} from './types';

const fetchOrder = (orderId: string): FetchOrderAction => ({
  type: FETCH_ORDER,
  payload: {
    orderId,
  },
});

const fetchOrderFulfilled = (orderId: string, response: DetailedOrderType): FetchOrderFulfilledAction => ({
  type: FETCH_ORDER_FULFILLED,
  payload: {
    orderId,
    data: response,
  },
});

const fetchOrderRejected = (orderId: string, error: ErrorType): FetchOrderRejectedAction => ({
  type: FETCH_ORDER_REJECTED,
  payload: {
    orderId,
    error,
  },
});

const clearAccountOrder = (): ClearAccountOrderAction => ({
  type: CLEAR_ACCOUNT_ORDER,
});

const clearOrderModifications = (): ClearOrderModificationsAction => ({
  type: CLEAR_ORDER_MODIFICATIONS,
});
const cancelOrder = (orderId: string): CancelOrderAction => ({
  type: CANCEL_ORDER,
  payload: {
    orderId,
  },
});

const cancelOrderFulfilled = (): CancelOrderFulfilledAction => ({
  type: CANCEL_ORDER_FULFILLED,
});

const cancelOrderRejected = (orderId: string, error: ErrorType): CancelOrderRejectedAction => ({
  type: CANCEL_ORDER_REJECTED,
  payload: {
    orderId,
    error,
  },
});

const cancelOrderItems = (orderId: string, data: RequestCancelOrderItemsType): CancelOrderItemsAction => ({
  type: CANCEL_ORDER_ITEMS,
  payload: {
    data,
    orderId,
  },
});

const cancelOrderItemsFulfilled = (): CancelOrderItemsFulfilledAction => ({
  type: CANCEL_ORDER_ITEMS_FULFILLED,
});

const cancelOrderItemsRejected = (orderId: string, error: ErrorType): CancelOrderItemsRejectedAction => ({
  type: CANCEL_ORDER_ITEMS_REJECTED,
  payload: {
    orderId,
    error,
  },
});

const splitOrder = (orderId: string): SplitOrderAction => ({
  type: SPLIT_ORDER,
  payload: {
    orderId,
  },
});

const splitOrderFulfilled = (): SplitOrderFulfilledAction => ({
  type: SPLIT_ORDER_FULFILLED,
});

const splitOrderRejected = (orderId: string, error: ErrorType): SplitOrderRejectedAction => ({
  type: SPLIT_ORDER_REJECTED,
  payload: {
    orderId,
    error,
  },
});

export {
  cancelOrder,
  cancelOrderFulfilled,
  cancelOrderItems,
  cancelOrderItemsFulfilled,
  cancelOrderItemsRejected,
  cancelOrderRejected,
  clearAccountOrder,
  clearOrderModifications,
  fetchOrder,
  fetchOrderFulfilled,
  fetchOrderRejected,
  splitOrder,
  splitOrderFulfilled,
  splitOrderRejected,
};
